<template>
    <div>
        <!-- 图片验证码 -->
        <captcha ref="captcha"  :captcha="captcha"/>
        <!-- 短信验证码 -->
        <van-field
            v-model="smsCode"
            center
            clearable
            label="短信验证码"
            placeholder="请输入短信验证码"
        >
            <template #button>
                <van-button size="small" @click="sendSms" type="primary" :disabled="!enableCaptchaBtn">
                    {{codeBtnText}}
                </van-button>
            </template>
        </van-field>
    </div>
</template>

<script>
import Captcha from "./captcha";
import {Toast} from "vant";
import {sendSmsCode} from "@/api/CommonApi";
export default {
    name: "sms-code",
    components:{Captcha},
    props:['form'],
    data(){
        return{
            codeBtnText:"发送验证码",
            captcha: {
                key:'',
                value:''
            },
        }
    },
    computed:{
        enableCaptchaBtn(){
            return this.form.phone && this.captcha.value && this.codeBtnText === '发送验证码'
        },
        smsCode:{
            get(){
                return this.form.code
            },
            set(v){
                // eslint-disable-next-line vue/no-mutating-props
                this.form.code = v
            }
        }
    },
    methods:{
        // 发送图形验证码
        sendSms(){
            if(this.isSend) return
            if(!this.captcha.value){
                return Toast.fail('请填写图形验证码')
            }
            const captcha = Object.assign({},this.captcha)
            sendSmsCode(this.form.phone,captcha).then(res => {
                console.log(res)
                if(!res.success){
                    throw new Error(res.message)
                }
                Toast.success(res.message);
                this.setBtnTimeout()
            }).catch(err => {
                this.$refs.captcha.changeCaptcha()
                Toast.fail(err.message);
                if(err === '图片验证码错误' || err.message === '图片验证码错误'){
                    return
                }
                this.setBtnTimeout()
            })
        },
        setBtnTimeout(){
            const start = Date.now()
            this.codeBtnText = `剩余60秒`
            this.isSend = true
            const i = setInterval(() => {
                const now = Date.now()
                const d = now - start
                if(d >= 60 * 1000){
                    this.codeBtnText = '发送验证码'
                    clearInterval(i)
                    return
                }
                this.codeBtnText = `剩余${parseInt(60 - d / 1000)}秒`
            },1000)
        },
    }
}
</script>

<style scoped>

</style>
